import { createNamespace } from '../utils'; // Components

import BaseInfo from './components/baseInfo';
import DrugInfo from './components/drugInfo';
import NewCheckInfo from './components/newCheckInfo';

var _createNamespace = createNamespace('prescription'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: Number,
      default: 1
    },
    imgServer: String
  },
  data: function data() {
    return {};
  },
  render: function render() {
    var h = arguments[0];
    var detail = this.detail,
        type = this.type,
        imgServer = this.imgServer;
    return h("div", {
      "class": bem()
    }, [h(BaseInfo, {
      "attrs": {
        "detail": detail,
        "type": type
      }
    }), h(DrugInfo, {
      "attrs": {
        "detail": detail,
        "type": type
      }
    }), h(NewCheckInfo, {
      "attrs": {
        "detail": detail,
        "type": type,
        "imgServer": imgServer
      }
    })]);
  }
});